import {useHistory} from 'react-router-dom'
import {AlertDialog} from '../Common/Dialog'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import messages from '../../assets/messages'
import {Account} from '../../graphql/types'

type WithdrawalBlockedPopupProps = {
  open: boolean
  onClose: () => void
  account: Account
} & WithNamespaces

const titleI18nKey = 'withdrawalBlockedTitle'
const messageLine1Key = 'withdrawalBlockedLine1'
const messageLine2Key = 'withdrawalBlockedLine2'

const agreeI18nKey = 'viewOpenPositions'
const disagreeI18nKey = 'withdrawalBlockedClose'

const _WithdrawalBlockedPopup: React.FC<WithdrawalBlockedPopupProps> = ({onClose, open, account, t}) => {
  const history = useHistory()

  const handleViewPositions = () => {
    history.push(`/accounts/${account.id}`)
  }

  const agreeText = t(messages[agreeI18nKey].i18nKey, messages[agreeI18nKey].defaults).toUpperCase()
  const disagreeText = t(messages[disagreeI18nKey].i18nKey, messages[disagreeI18nKey].defaults).toUpperCase()
  const title = t(messages[titleI18nKey].i18nKey, messages[titleI18nKey].defaults)

  return (
    <AlertDialog
      agreeText={agreeText}
      disagreeText={disagreeText}
      onAgree={handleViewPositions}
      onDisagree={onClose}
      onClose={onClose}
      open={open}
      title={title}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography align="center">
            <Trans {...messages[messageLine1Key]} />
          </Typography>
          <Typography align="center">
            <Trans {...messages[messageLine2Key]} />
          </Typography>
        </Grid>
      </Grid>
    </AlertDialog>
  )
}

export const WithdrawalBlockedPopup = withNamespaces()( _WithdrawalBlockedPopup )
